import { EContentFullscreenActionTypes } from '../../actions/contentFullscreen';
import { TAppState } from '../../types/appState';
import { TReduxActions } from '../../types/redux/actions';

export const contentFullscreenReducer = (state: TAppState, action: TReduxActions): TAppState => {
  switch (action.type) {
    case EContentFullscreenActionTypes.Open:
      return {
        ...state,
        contentFullscreen: {
          isOpen: true,
          selectedImageUid: action.payload.selectedImageUid,
        },
      };

    case EContentFullscreenActionTypes.Set:
      return {
        ...state,
        contentFullscreen: {
          isOpen: true,
          selectedImageUid: action.payload.selectedImageUid,
        },
      };

    case EContentFullscreenActionTypes.Close:
      return {
        ...state,
        contentFullscreen: {
          isOpen: false,
          selectedImageUid: null,
        },
      };

    default:
      return state;
  }
};
